import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { PageLayout } from '../components/layout';

const Dashboard = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  useEffect(() => {
    // Using a potentially simpler key or a good default for the title
    document.title = t('dashboard.pageTitle', 'Dashboard');
  }, [t]);

  // Get first name and capitalize it
  const namePart = user?.name ? user.name.split(' ')[0] : '';
  const firstName = namePart.charAt(0).toUpperCase() + namePart.slice(1);

  return (
    <PageLayout
      title={t('dashboard.title', "Hello {{firstName}} — Here\'s your Social Media overview", { firstName: firstName || 'there' })}
      subtitle={t('dashboard.subtitle', 'This is your content command center. Track, plan and optimize your content with the help of AI insights and recommendations.')}
    >
      {/* Content for the dashboard page will go here */}
      <div className="bg-gray-100 border border-gray-200 rounded-lg p-8 text-center">
        <p className="text-gray-500">Dashboard content coming soon...</p>
      </div>
    </PageLayout>
  );
};

export default Dashboard; 